import React, { useState } from 'react';
import { AdminLayout } from '../components/admin/AdminLayout';
import { VehicleTable } from '../components/admin/VehicleTable';
import { VehicleForm } from '../components/admin/VehicleForm';
import { PlusIcon } from 'lucide-react';
interface Vehicle {
  id: number;
  name: string;
  model: string;
  price: string;
  image: string;
  year: string;
  mileage: string;
  condition: 'New' | 'Used';
  transmission: string;
  fuelType: string;
}
const initialVehicles: Vehicle[] = [{
  id: 1,
  name: 'Rolls-Royce',
  model: 'Phantom',
  price: '$485,000',
  year: '2024',
  mileage: '1,200 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1631295868223-63265b40d9e4?q=80&w=800&auto=format&fit=crop'
}, {
  id: 2,
  name: 'Mercedes-Benz',
  model: 'S-Class S 500',
  price: '$125,000',
  year: '2024',
  mileage: '3,200 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?q=80&w=800&auto=format&fit=crop'
}, {
  id: 3,
  name: 'BMW',
  model: 'M5 Competition',
  price: '$115,000',
  year: '2024',
  mileage: '1,800 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?q=80&w=800&auto=format&fit=crop'
}];
export function AdminVehicles() {
  const [vehicles, setVehicles] = useState<Vehicle[]>(initialVehicles);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingVehicle, setEditingVehicle] = useState<Vehicle | undefined>(undefined);
  const handleAddVehicle = (vehicleData: Omit<Vehicle, 'id'>) => {
    const newVehicle = {
      ...vehicleData,
      id: Math.max(...vehicles.map(v => v.id), 0) + 1
    };
    setVehicles([...vehicles, newVehicle]);
    setIsFormOpen(false);
  };
  const handleEditVehicle = (vehicleData: Omit<Vehicle, 'id'>) => {
    if (editingVehicle) {
      setVehicles(vehicles.map(v => v.id === editingVehicle.id ? {
        ...vehicleData,
        id: editingVehicle.id
      } : v));
      setEditingVehicle(undefined);
      setIsFormOpen(false);
    }
  };
  const handleDeleteVehicle = (id: number) => {
    setVehicles(vehicles.filter(v => v.id !== id));
  };
  const openAddForm = () => {
    setEditingVehicle(undefined);
    setIsFormOpen(true);
  };
  const openEditForm = (vehicle: Vehicle) => {
    setEditingVehicle(vehicle);
    setIsFormOpen(true);
  };
  const closeForm = () => {
    setIsFormOpen(false);
    setEditingVehicle(undefined);
  };
  return <AdminLayout data-id="element-254">
      <div className="p-8" data-id="element-255">
        <div className="flex items-center justify-between mb-8" data-id="element-256">
          <div data-id="element-257">
            <h1 className="text-3xl font-bold text-white mb-2" data-id="element-258">
              Vehicle Management
            </h1>
            <p className="text-gray-400" data-id="element-259">Manage your car inventory</p>
          </div>
          <button onClick={openAddForm} className="flex items-center gap-2 px-6 py-3 bg-[var(--color-gold)] text-black font-semibold rounded-lg hover:bg-[var(--color-gold)]/90 transition-colors" data-id="element-260">
            <PlusIcon className="w-5 h-5" aria-hidden="true" data-id="element-261" />
            Add Vehicle
          </button>
        </div>

        <div className="bg-[var(--color-black-rich)] border border-gray-800 rounded-lg overflow-hidden" data-id="element-262">
          <VehicleTable vehicles={vehicles} onEdit={openEditForm} onDelete={handleDeleteVehicle} data-id="element-263" />
        </div>
      </div>

      {isFormOpen && <VehicleForm vehicle={editingVehicle} onSave={editingVehicle ? handleEditVehicle : handleAddVehicle} onCancel={closeForm} data-id="element-264" />}
    </AdminLayout>;
}